import getConfig from "next/config";

import StoreSchedule from "@components/ProductPage/ProductStoreAvailability/StoreSchedule";
import StoreSpecialSchedule from "@components/ProductPage/ProductStoreAvailability/StoreSpecialSchedule";
import StoreStockStatus from "@components/ProductPage/ProductStoreAvailability/StoreStockStatus";
import Price from "@components/Price";
import AddToCartReserveInStore from "@components/AddToCartReserveInStore";
import HeartMarker from "@components/Icons/HeartMarker";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const AvailableStoresModalStoreCard = ({
  storeData,
  onStoreSelect,
  selectedStoreId,
  product,
}) => {
  const hasSpecialSchedule = Boolean(storeData.special_schedule);
  const isSelectedStore = selectedStoreId === storeData.id;

  return (
    <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-[20px]">
      <div className="text-[14px]">
        <StoreStockStatus quantity={storeData.qty} />

        <div className="flex flex-col sm:flex-row sm:items-center sm:gap-[10px]">
          {storeData?.name && <div>{storeData.name}</div>}

          {!isSelectedStore && (
            <a
              className="flex items-center cursor-pointer text-red-brand text-[14px] font-medium"
              href="#"
              rel="noopener noreferrer"
              onClick={(event) => {
                event.preventDefault();
                onStoreSelect(storeData);
              }}
            >
              <HeartMarker />
              Seteaza ca magazin favorit
            </a>
          )}
        </div>

        {storeData.address && storeData.address}

        {hasSpecialSchedule ? (
          <StoreSpecialSchedule schedule={storeData.special_schedule} />
        ) : (
          <StoreSchedule schedule={storeData.schedule} />
        )}

        <a
          href={`${settings.baseUrl}/magazine/${storeData.url_key}/`}
          rel="noopener noreferrer"
          target="_blank"
          className="text-red-brand hover:text-bleu-hover underline"
          title=""
        >
          Vezi harta
        </a>
      </div>

      <div className="flex flex-col md:flex-row gap-[10px] md:gap-[20px] min-w-fit">
        <Price
          productId={parseInt(product.id)}
          price={product.priceInfo.selling_price || product.price}
          regularPrice={product.priceInfo.base_price}
          formatted={true}
          size="smaller"
          displayDiscount={true}
          msrp={product.msrp_price}
          discountType={product.discount_type}
        />

        <AddToCartReserveInStore product={product} />
      </div>
    </div>
  );
};

export default AvailableStoresModalStoreCard;
